import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { EvaluatorOperationsDashboard } from "@/features/evaluator-operations/dashboard/evaluator-operations-dashboard";

export const Route = createFileRoute("/evaluators/dashboard")({
  component: () => (
    <PermissionGuard module="evaluators">
      <EvaluatorOperationsDashboard />
    </PermissionGuard>
  ),
});
